import { Step } from 'react-joyride'

export enum DesignTourStepIndex {
  CUSTOMIZE_TEMPLATE = 0,
  SELECT_TEMPLATE = 1,
  SELECT_COLOR = 2,
}

export enum EditorTourStepIndex {
  EDIT_RESUME = 0,
  DRAG_SECTIONS = 1,
  PHRASES_SUGGESTIONS = 2,
  DOWNLOAD_RESUME = 0,
}

export type StepName = 'design' | 'editor' | 'download'
export type Steps = {
  stepName: StepName
  steps: Step[]
}

export type StepsHookProps = {
  onChangeSteps: () => void
}
